import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import * as _ from "lodash"
import { TOverlayProps } from "./Overlay";
import OverlayContainers, { IOverlayContainers, TOverlayContainer } from "./OverlayContainers";

export type TOverlayContext = {
    addOverlay:(id:string, overlayProps:TOverlayProps) => string
    popOverlay:(id?:string) => void
    hasOverlay:(overlayId:string) => boolean
}

const OverlayContext = createContext<TOverlayContext>({} as any)

var g_id = 0
export const useOverlay = () => useContext(OverlayContext)

function OverlayDebugger(props:{overlays:TOverlayContainer[]}) {
    const overlayIds = props.overlays.map( (overlay,i) => <div key={i.toString()+":"+overlay.id}>{`${overlay.id}/${overlay.overlayId}`}</div>)
    return <div className="overlay debug">{overlayIds}</div>
}
export default function OverlayProvider(props:TOverlayProps) {
    const [overlays,setOverlays] = useState<TOverlayContainer[]>([])
    const ref = useRef<IOverlayContainers|null>(null)
    const overlaysRef = useRef<TOverlayContainer[]>(overlays)
    overlaysRef.current = overlays

    const topActive = (overlays:TOverlayContainer[], id?:string|undefined) => id ? _.find(overlays, o => o.id==id || o.overlayId==id) : _.findLast(overlays, o => o.active)
    const addOverlay = (id:string, overlayProps:TOverlayProps) => {
        const index = overlays.findIndex(o => o.id==id)
        if (index>=0) {
            const existing = overlays[index]
            if (!existing.active) {
                existing.active = true
                setOverlays( overlays => [...overlays] )
                return existing.overlayId
            }
            else console.warn("Duplicate overlay", id, existing)
        }

        const overlayId = `overlay_${g_id++}`
        setOverlays( overlays => [...overlays, {id,overlayId,overlayProps,active:true,dismissed:false}] )
        return overlayId
    }
    const onDestroy = (id:string|undefined, dismissed:boolean) => {
        setOverlays( overlays => {
            const top = topActive(overlays, id)
            if (!top) return overlays
            else {
                top.active = false
                top.dismissed = dismissed
                return [...overlays]
            }
        })
    }
    const popOverlay = (id?:string) => onDestroy(id, false)
    const onDismiss = (id?:string) => onDestroy(id, true)
    const onDismissed = (id?:string) => {
        setOverlays(overlays => {
            const top = topActive(overlays, id)
            if (top) {
                _.pull(overlays, top)
                top.dismissed && top.overlayProps.onDismissed?.()
                return [...overlays]
            }
            else return overlays
        })
    }
    const hasOverlay = (id:string) => !!topActive(overlaysRef.current, id)

    const onDown = (e:PointerEvent) => ref.current?.onDown(e)
    useEffect(() => {
        document.addEventListener("pointerdown", onDown)
        return () => { document.removeEventListener("pointerdown", onDown) }
    }, [])
    
    const debug = document.location.search.indexOf("debug")>0 ? <OverlayDebugger overlays={overlays}/> : null
    return <OverlayContext.Provider value={{addOverlay,popOverlay,hasOverlay}}>
        {props.children}
        <OverlayContainers containers={overlays} onDismissed={onDismissed} onDismiss={onDismiss} ref={ref}/>
        {debug}
    </OverlayContext.Provider>
}